import { FormattedMessage as FM } from "react-intl";

import Loading from "componentsv2/widgets/Loading";
import { cn } from "tools/ui";

const base =
  "flex mx-auto rounded-lg border border-dashed border-neutral-400 h-60 p-10";

function NoDataSheet({ msg }) {
  let component = <Loading />;
  if (msg !== "is_loading") {
    component = (
      <span>
        <FM id={`hotel.calendar.${msg}`} />
      </span>
    );
  }
  return (
    <div className={cn(base)}>
      <div className="mx-auto my-auto text-3xl text-neutral-400 font-bold">
        {component}
      </div>
    </div>
  );
}

export default NoDataSheet;
